module.exports = __webpack_public_path__ + "static/Julia-Constantine-2bb9566ec7bbe5a8d6feecdcc98282ff.jpg";